<template>
  <DropdownItemView
    :has-link="canRedirectToBillingPage"
    :data-e2e="NavCypressAttribute.buttons.BILLING_DROPDOWN"
  >
    <router-link
      v-if="canRedirectToBillingPage"
      :to="{ name: 'billing' }"
      class="has-text-black"
      :data-e2e="NavCypressAttribute.buttons.BILLING_ROUTER"
    >
      <i class="icon cls cls-accounting-document"></i>
      {{ $t('billing.billing') }}
    </router-link>
    <template v-else>
      <LoadingView :active="isLoading">
        <IconView pack="cls" size="is-small" custom-class="cls cls-synchronize-arrow spin m-t-5" />
      </LoadingView>
      <div
        @click.stop="openStripeBillingPortalSession"
        :data-e2e="NavCypressAttribute.buttons.BILLING"
      >
        <i class="icon cls cls-accounting-document"></i>
        {{ $t('billing.billing') }}
      </div>
    </template>
  </DropdownItemView>
</template>

<script>
import { BillingCypressAttribute } from '/@/modules/billing/constants/BillingCypressAttribute';
import { HasCurrentEstateMixin } from '/@/modules/core/app/mixins/HasCurrentEstateMixin';
import { NavCypressAttribute } from '/@/modules/core/nav/constants/NavCypressAttribute';
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import DropdownItemView from '@/modules/core/ui/components/wrappers/DropdownItemView.vue';
import IconView from '@/modules/core/ui/components/wrappers/IconView.vue';
import LoadingView from '@/modules/core/ui/components/wrappers/LoadingView.vue';
import StripeBillingPortalSessionService from '@/modules/billing/services/stripe/StripeBillingPortalSessionService';
import BillingDashboardAccessService from '@/modules/billing/services/BillingDashboardAccessService';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'BillingDropdownItem',
  mixins: [HasAuthUserMixin, HasCurrentEstateMixin],
  components: { DropdownItemView, IconView, LoadingView },
  static: {
    NavCypressAttribute,
    BillingCypressAttribute
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    canRedirectToBillingPage() {
      return BillingDashboardAccessService.canAccessBillingDashboard(
        this.authUser,
        this.currentEstate
      );
    }
  },
  methods: {
    async openStripeBillingPortalSession() {
      if (this.isLoading) {
        return;
      }

      try {
        this.isLoading = true;
        await StripeBillingPortalSessionService.startSession();
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
